export default function Features() {
  const features = [
    {
      title: 'Advanced Security',
      description: 'Military-grade encryption protocols protect your data and online activities from prying eyes and cyber threats.',
      icon: 'ri-shield-check-line',
      image: 'https://public.readdy.ai/ai/img_res/ecae65573d906806e062dc8c5a2960ad.jpg'
    },
    {
      title: 'Smart Optimization',
      description: 'Intelligent algorithms analyze and optimize your device performance automatically.',
      icon: 'ri-flashlight-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20optimization%20illustration%20with%20soft%20blue%20gradient%20background%20abstract%20speed%20or%20performance%20symbol%20clean%20geometric%20design%20professional%20efficiency%20concept%20elegant%20visual&width=400&height=300&seq=feature-optimization&orientation=portrait'
    },
    {
      title: 'Real-time Protection',
      description: 'Continuous monitoring ensures your device stays secure around the clock.',
      icon: 'ri-time-line',
      image: 'https://readdy.ai/api/search-image?query=elegant%20minimalist%20real-time%20monitoring%20illustration%20with%20soft%20purple%20gradient%20background%20abstract%20clock%20or%20radar%20symbol%20clean%20modern%20design%20professional%20surveillance%20concept%20sophisticated%20visual&width=400&height=300&seq=feature-realtime&orientation=portrait'
    }
  ];

  return (
    <section id="features" className="py-32 bg-[#F8FAFB]">
      <div className="container mx-auto px-16">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-4">
            <h3 className="text-6xl font-thin text-[#2A2A2A] leading-tight mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
              Powerful<br />Features
            </h3>
            <p className="text-base text-[#6B6B6B]">
              Everything you need for optimal performance
            </p>
          </div>

          <div className="col-span-8">
            <div className="grid grid-cols-5 gap-6">
              <div className="col-span-3 bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow duration-300">
                <div className="h-64">
                  <img 
                    src={features[0].image} 
                    alt={features[0].title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-8">
                  <div className="w-12 h-12 flex items-center justify-center mb-4">
                    <i className={`${features[0].icon} text-4xl text-[#1A3A3A]`}></i>
                  </div>
                  <h4 className="text-2xl font-bold text-[#2A2A2A] mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {features[0].title}
                  </h4>
                  <p className="text-sm text-[#6B6B6B] leading-relaxed">
                    {features[0].description}
                  </p>
                </div>
              </div>

              <div className="col-span-2 bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow duration-300">
                <div className="p-8 text-center">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                    <i className={`${features[1].icon} text-4xl text-[#1A3A3A]`}></i>
                  </div>
                  <h4 className="text-xl font-bold text-[#2A2A2A] mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {features[1].title}
                  </h4>
                </div>
                <div className="h-48">
                  <img 
                    src={features[1].image} 
                    alt={features[1].title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <p className="text-sm text-[#6B6B6B] leading-relaxed text-center">
                    {features[1].description}
                  </p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-5 gap-6 mt-6">
              <div className="col-span-2 bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow duration-300">
                <div className="p-8 text-center">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                    <i className={`${features[2].icon} text-4xl text-[#1A3A3A]`}></i>
                  </div>
                  <h4 className="text-xl font-bold text-[#2A2A2A] mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {features[2].title}
                  </h4>
                </div>
                <div className="h-48">
                  <img 
                    src={features[2].image} 
                    alt={features[2].title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <p className="text-sm text-[#6B6B6B] leading-relaxed text-center">
                    {features[2].description}
                  </p>
                </div>
              </div>

              <div className="col-span-3 bg-white rounded-3xl p-10 shadow-sm hover:shadow-lg transition-shadow duration-300 flex flex-col justify-center">
                <h4 className="text-3xl font-bold text-[#2A2A2A] mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Why Choose Our Apps?
                </h4>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-xl text-[#1A3A3A] mt-1"></i>
                    <span className="text-sm text-[#6B6B6B]">Intuitive user interface designed for iOS</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-xl text-[#1A3A3A] mt-1"></i>
                    <span className="text-sm text-[#6B6B6B]">Regular updates with new features</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-xl text-[#1A3A3A] mt-1"></i>
                    <span className="text-sm text-[#6B6B6B]">24/7 customer support</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-xl text-[#1A3A3A] mt-1"></i>
                    <span className="text-sm text-[#6B6B6B]">No logs policy for complete privacy</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
